import React, { useMemo } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import { injectIntl } from 'react-intl';
import DeliveriesFilter from './deliveries-filter/DeliveriesFilter';
import DeliveriesTable from './deliveries-table/DeliveriesTable';
import { useDeliveriesUIContext } from './DeliveriesUIContext';

const DeliveriesCard = (props) => {
  const { intl } = props;
  const title = intl.formatMessage({ id: 'DELIVERIES.TITLE.LIST' });
  const deliveriesUIContext = useDeliveriesUIContext();
  const deliveriesUIProps = useMemo(() => {
    return {
      queryParams: deliveriesUIContext.queryParams,
      setQueryParams: deliveriesUIContext.setQueryParams,
      openViewDeliverDialog: deliveriesUIContext.openViewDeliverDialog,
      openCreateDeliverDialog: deliveriesUIContext.openCreateDeliverDialog,
      openDeleteDeliveriesDialog:
        deliveriesUIContext.openDeleteDeliveriesDialog,
    };
  }, [deliveriesUIContext]);

  return (
    <Card id='deliveriesCard'>
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={deliveriesUIProps.openCreateDeliverDialog}
          >
            Хүргэлт бүртгэх
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <DeliveriesFilter props />
        <DeliveriesTable props />
      </CardBody>
    </Card>
  );
};

export default injectIntl(DeliveriesCard);
